import React from 'react'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'
import NewElementObject from '../NewElementObject'
import SiteVars from '~/Classes/siteVars'

const AppHolder = ({ app, userApps, onDrag, index }) => {
    var bgImage = ''
    var thisOpts = DragDropFunctions.replaceGlobalOptions(app.options)
    bgImage = thisOpts.appBgImage

    var hasAppInstalled = false
    if (!app.forAppId) hasAppInstalled = true
    if (!hasAppInstalled) {
        hasAppInstalled = userApps.find((tApp) => tApp.ApplicationId == app.forAppId)
    }

    if (!hasAppInstalled) return null

    const appIcon = app.options.appBgImage.replace(/\[REPOENDPOINT\]/g, SiteVars.repoEndPoint)

    return (
        <NewElementObject
            id={'newEl-' + index}
            title={app.name}
            showLogo={true}
            toolbarIcon={appIcon}
            content={thisOpts.content}
            onStartDrag={onDrag}
        />
    )
}

export default AppHolder
